import AIAssistant from './AIAssistant'

export default AIAssistant;